module.exports = __webpack_public_path__ + "img/icon-load-control.f44a2076.svg";